export default {
  data() {
    return {
      captcha: null,
    };
  },
  mounted() {
    if (window.TencentCaptcha) {
      this.captcha = new window.TencentCaptcha(
        "194976309",
        this.captchaCallback,
        {}
      );
    }
  },
};
